module.exports = __webpack_public_path__ + "img/energy.5558b498.svg";